const excludeUrlsForLuobu = ['https://vitals.vercel-insights.com/v1/vitals'];
export default excludeUrlsForLuobu;
